import React, { Component } from "react";
import { Button } from "../../../common/Button/Button";
import CheckBoxContainer from "../../../common/CheckboxContainer/CheckboxContainer"
import moment from 'moment';

class SelectPaymentStatusDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title
    };
  }

  

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        document.addEventListener("click", this.close);
      } else {
        document.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close = (e) => {
    if(this.paymentStatus.contains(e.target)){
      return
    }
    this.setState({
      listOpen: false
    });
  }

  toggleList() {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }));
  }

  renderPaymentStatus = () => {
    // const {auditLog = []} = this.props;
      return(
        <div><CheckBoxContainer showSelectAll={false} toggleSelection={this.props.togglePaymentStatus}  checkboxItemsList={this.props.checkboxItemsList}/></div>
      )
    
  }


  
  render() {
    const { listOpen } = this.state;
    return (
      <div ref={elem => this.paymentStatus = elem}>
        <Button className="inline-button" onClick={() => this.toggleList()}>Select Payment Status</Button>
        {listOpen && (
          <div className="dd-list selectServiceType">
            <div>
              {this.renderPaymentStatus()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SelectPaymentStatusDropdown;
